export enum StudentEstimateStateEnum {
  None,
  AllStudents,
  ZeroStudents,
}
